import { search } from '../../utils/utils'

const getters = {
    offers: (state) => state.list,
    filterOffers: state => {
        return (filter) => {
            return search(state.list, filter)
        }
    },
    offerErrors: state => state.errors
}

export default getters
